import clsx from 'clsx';
import { Box } from '../../../box';
import { Text } from '../../../../foundations';
import styles from '../../Summary.module.css';

export type SummaryArticleProps = {
	amount?: number;
	amountEnd?: boolean;
	text: string;
	price?: string;
	onClick?: () => void;
};

export const SummaryArticle = (props: SummaryArticleProps) => {
	const { amountEnd, amount, text, price, onClick } = props;
	return (
		<Box className={styles.summary_item_body}>
			<Text className={styles.summary_item_content} font="verdana" size="lg-regular">
				{!amountEnd && amount ? `${String(amount)} ${text}` : text}
			</Text>
			<Text
				className={clsx({
					[styles.summary_price_black]: amountEnd,
					[styles.summary_subitem_click]: onClick
				})}
				font="verdana"
				size="lg-regular"
				onClick={onClick && onClick}
			>
				{amountEnd && amount ? `${String(amount)} x ${String(price)}` : price}
			</Text>
		</Box>
	);
};
SummaryArticle.displayName = 'SummaryArticle';
